export const NO_REFETCH_OPTIONS = {
  refetchOnMount: true,
  refetchInterval: false,
  refetchIntervalInBackground: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
} as const
